export const K12GradeLevels = Object.freeze({
  G12: 0,
  G11: 1,
  G10: 2,
  G09: 3,
  G08: 4,
  G07: 5,
  G06: 6,
  G05: 7,
  G04: 8,
  G03: 9,
  G02: 10,
  G01: 11,
  GK: 12,
});

export const GRADE_LEVELS = [
  {
    label: "Kindergarten",
    key: K12GradeLevels.GK,
  },
  {
    label: "1st Grade",
    key: K12GradeLevels.G01,
  },
  {
    label: "2nd Grade",
    key: K12GradeLevels.G02,
  },
  {
    label: "3rd Grade",
    key: K12GradeLevels.G03,
  },
  {
    label: "4th Grade",
    key: K12GradeLevels.G04,
  },
  {
    label: "5th Grade",
    key: K12GradeLevels.G05,
  },
  {
    label: "6th Grade",
    key: K12GradeLevels.G06,
  },
  {
    label: "7th Grade",
    key: K12GradeLevels.G07,
  },
  {
    label: "8th Grade",
    key: K12GradeLevels.G08,
  },
  {
    label: "9th Grade",
    key: K12GradeLevels.G09,
  },
  {
    label: "10th Grade",
    key: K12GradeLevels.G10,
  },
  {
    label: "11th Grade",
    key: K12GradeLevels.G11,
  },
  {
    label: "12th Grade",
    key: K12GradeLevels.G12,
  },
];
